// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__1JXf0","title":"AfterImages45_title__3MPUr","images":"AfterImages45_images__1IZe5"};